import React from 'react';
import { LuSquareParking } from "react-icons/lu";
import { FaBellConcierge } from "react-icons/fa6";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { GiCctvCamera } from "react-icons/gi";
import './Amenties.css';

const AddAmenties = () => {
  const sections = [
    {
      title: "Parking Space",
      text: "Our facility offers ample and secure parking space to ensure convenience and safety for all guests and visitors. The parking area is well-monitored and easily accessible.",
      icon: <LuSquareParking size ={120} />,
      list: [
        "Ample and well-organized parking area for hassle-free vehicle accommodation.",
        "24x7 CCTV surveillance to ensure vehicle safety and prevent unauthorized access.",
        "Designated spots for guests, staff, and VIPs for better convenience.",
        "Easily accessible entry and exit points with proper signage for smooth traffic flow.",
      ],
      bgClass: "choice-based",
    },
    {
      title: "Concierge Services",
      text: "Our professional concierge team is dedicated to assisting guests with personalized services, including travel arrangements, reservations, and special requests for a seamless experience.",
      icon: <FaBellConcierge size ={120}/>,
      list: [
        "Personalized assistance for travel bookings, reservations, and special requests.",
        "Handling of guest inquiries, event planning, and local recommendations.",
        "Professional staff trained to provide courteous and efficient service.",
        "Available 24x7 to ensure convenience for all guests and residents."
      ],
      bgClass: "programs-tailored",
    },
    {
      title: "24/7 Security",
      text: "Our facility ensures complete safety with 24x7 security services, including CCTV surveillance, trained security personnel, and secure access controls for a protected environment.",
      icon: <GiCctvCamera size={120}/>,
      list: [
        "Continuous CCTV monitoring to cover all entry, exit, and common areas.",
        "Trained security personnel stationed at key locations for added protection.",
        "Regular security audits and emergency response protocols."
      ],
      bgClass: "project-based",
    },
    {
      title: "Customizable Packages",
      text: "Our customizable packages are designed to cater to diverse needs, allowing clients to tailor services and amenities according to their preferences and requirements.",
      icon: <MdOutlineDashboardCustomize size={120}/>,
      list: [
        "Tailored service packages based on individual preferences and needs.",
        "Options to add or remove services such as housekeeping, meals, and wellness programs.",
        "Flexible pricing structures to accommodate different budgets.",
        "Ideal for both short-term and long-term service arrangements."
      ],
      bgClass: "mooc",
    }
  ];

  return (
    <div className="academics-overview-container-main2">
      <h1 className="section-heading">BEYOND EXPECTATION</h1>
      <p className='section-para'>Our commitment to excellence extends
          beyond our rooms and recreational
          spaces. Enjoy a range of premium
          amenities designed to make your stay
          truly delightful.</p>
      <div className="academics-overview-container">
        {sections.map((section, index) => (
          <div
            key={index}
            className={`academics-overview-section ${section.bgClass} ${index % 2 !== 0 ? 'reverse-order' : ''}`}
          >
            <div className="academics-overview-icon">{section.icon}</div>
            <div className="academics-overview-content">
              <h2 className="academics-overview-title">{section.title}</h2>
              <p className="academics-overview-text">{section.text}</p>
              <ul className="academics-overview-list">
                {section.list.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddAmenties;
